import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  maxWidth?: string;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'max-w-2xl'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-172">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-6" onClick={onClose} data-id="element-173">
          <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" data-id="element-174"></div>

          <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className={`relative ${maxWidth} w-full max-h-[85vh] bg-darker border border-border shadow-2xl flex flex-col`} onClick={e => e.stopPropagation()} data-id="element-175">
            <div className="absolute top-0 left-0 w-full h-1 bg-blood" data-id="element-176"></div>

            {title && <div className="flex items-center justify-between px-6 md:px-8 pt-8 pb-4 border-b border-border" data-id="element-177">
                <h3 className="text-2xl md:text-3xl font-serif font-bold text-foreground" data-id="element-178">
                  {title}
                </h3>
                <button onClick={onClose} className="text-foreground/50 hover:text-blood transition-colors p-1" aria-label="Cerrar" data-id="element-179">
                  <X size={24} data-id="element-180" />
                </button>
              </div>}

            {!title && <button onClick={onClose} className="absolute top-4 right-4 text-foreground/50 hover:text-blood transition-colors p-1 z-10" aria-label="Cerrar" data-id="element-181">
                <X size={24} data-id="element-182" />
              </button>}

            <div className="overflow-y-auto px-6 md:px-8 py-6" data-id="element-183">{children}</div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}